// extracted by mini-css-extract-plugin
module.exports = {"ofzv9i5":"ofzv9i5","cts0t3k":"cts0t3k","s1x8d8sp":"s1x8d8sp","s1s5wfwx":"s1s5wfwx","s82l4rc":"s82l4rc","s1njrb8a":"s1njrb8a"};